import {
  FaUser,
  FaLock,
  FaHome,
  FaTrash,
  FaPencilAlt,
  FaPlus,
  FaExchangeAlt,
  FaRegFileAlt,
  FaRegChartBar,
  FaFileAlt,
  FaCogs,
  FaCheckCircle,
  FaCircle,
  FaArrowCircleRight,
  FaArrowRight,
  FaGlobe,
  FaBell,
  FaChevronDown,
  FaChevronUp,
  FaRegHourglass,
  FaRegEye,
  FaHeadphonesAlt,
  FaFileDownload,
  FaExclamationCircle,
} from "react-icons/fa";
import { FiLogOut } from "react-icons/fi";
import { HiDocumentDuplicate } from "react-icons/hi2";
import { CiCalendar } from "react-icons/ci";
import { 
  BsTicketPerforatedFill,
  BsFiletypePdf,
  BsFiletypeXls
 } from "react-icons/bs";
import { BiCheckCircle } from "react-icons/bi";

export const icons = {
  ChevronUp: FaChevronUp,
  ChevronDown: FaChevronDown,
  User: FaUser,
  Lock: FaLock,
  Home: FaHome,
  Trash: FaTrash,
  Plus: FaPlus,
  Pencil: FaPencilAlt,
  Logout: FiLogOut,
  Dashboard: FaRegChartBar,
  Transactions: FaExchangeAlt,
  Reports: FaRegFileAlt,
  LoanInformation: FaFileAlt,
  Settings: FaCogs,
  CircleCheck: FaCheckCircle,
  Circle: FaCircle,
  ArrowRight: FaArrowRight,
  ArrowCircleRight: FaArrowCircleRight,
  Globe: FaGlobe,
  Bell: FaBell,
  SupportTicket: BsTicketPerforatedFill,
  HourGlass: FaRegHourglass,
  Eye: FaRegEye,
  Headphones: FaHeadphonesAlt,
  FileDownload: FaFileDownload,
  DocumentDuplicate: HiDocumentDuplicate,
  Calendar: CiCalendar,
  Pdf: BsFiletypePdf,
  Xls: BsFiletypeXls,
  CheckCircle: BiCheckCircle,
};

export const AppIcon = ({ name, size = 20, color, cx }) => {
  const IconComponent = icons[name];
  return IconComponent ? <IconComponent size={size} color={color} className={cx} /> : null;
};
